(function () {
  function initFerrerHeader(root) {
    if (!root || root.dataset.ferrerHeaderInit === "true") return;
    root.dataset.ferrerHeaderInit = "true";

    var header = root.querySelector("[data-ferrer-header]");
    var toggle = root.querySelector("[data-ferrer-nav-toggle]");
    var overlay = root.querySelector("[data-ferrer-nav-overlay]");
    var panel = root.querySelector("[data-ferrer-nav-panel]");
    if (!header || !toggle || !overlay || !panel) return;

    function onScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    }

    function unlockScroll() {
      document.body.classList.remove("nav-open");
    }

    function closeNav() {
      panel.classList.remove("is-open");
      overlay.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      unlockScroll();
    }

    function openNav() {
      panel.classList.add("is-open");
      overlay.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
      document.body.classList.add("nav-open");
    }

    function toggleNav() {
      if (panel.classList.contains("is-open")) closeNav();
      else openNav();
    }

    function onKeydown(event) {
      if (event.key === "Escape") closeNav();
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("keydown", onKeydown);
    toggle.addEventListener("click", toggleNav);
    overlay.addEventListener("click", closeNav);

    panel.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeNav);
    });

    onScroll();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".ferrer-storefront").forEach(initFerrerHeader);
  });

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(".ferrer-storefront");
    if (root) initFerrerHeader(root);
  });
})();
